module.exports = __webpack_public_path__ + "img/about-glories1.28ee28d.png";